import React, { useState } from "react";
import DetailsModal from "./DetailsModal";

const DetailsCard = ({cardData}) => {
  const [detailsModal, setDetailsModal] = useState(false);

  const toggleDetailsModal = () => {
    setDetailsModal(!detailsModal);
  };

  return (
    <>
      <div className="campaign-card card--gameboard-card item-card">
        <div className="line-after"></div>
        <div className="campaign-card__header">
          <div className="campaign-card__title-wrapper">
            <span className="details-icon">
              <svg
                viewBox="0 0 20 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="icon__svg"
                preserveAspectRatio="xMidYMid meet"
                style={{ width: "20px", height: "20px" }}
              >
                <path
                  d="M3.5 0a3 3 0 00-3 3v12.015c0 1.645 1.355 3 3 3h13c1.645 0 3-1.355 3-3V3a3 3 0 00-3-3h-13zm-.25 2a.75.75 0 110 1.5.75.75 0 010-1.5zm2.5 0a.75.75 0 110 1.5.75.75 0 010-1.5zm3 0h8a.75.75 0 010 1.5h-8a.75.75 0 010-1.5zM2.5 5.5h15v9.515c0 .564-.436 1-1 1h-13c-.564 0-1-.436-1-1V5.5zM4.75 7a.75.75 0 00-.75.75v3c0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75v-3A.75.75 0 009.25 7h-4.5zm7.5 0a.75.75 0 00-.75.75v6c0 .414.336.75.75.75h3a.75.75 0 00.75-.75v-6a.75.75 0 00-.75-.75h-3zm-7.5 6a.751.751 0 100 1.5h4.5a.751.751 0 100-1.5h-4.5z"
                  fill="#29353D"
                ></path>
              </svg>
            </span>
            <div className="campaign-card__title">Details</div>
          </div>
        </div>
        <div className="campaign-card__content">
          <div className="card--item--type">&nbsp;</div>
          <div className="campaign-card--description details">
            Name: {cardData?.title}
          </div>
        </div>
        <div className="campaign-card__action__footer">
          <button className="campaign-button" onClick={toggleDetailsModal}>
            <span class="campaign-button__label">Edit</span>
          </button>
        </div>
      </div>
      <DetailsModal isOpen={detailsModal} onClose={toggleDetailsModal} cardData={cardData} />
    </>
  );
};

export default DetailsCard;
